import React, { createContext, useContext, useState, ReactNode } from 'react';

interface UIVisibilityContextType {
  isHeaderVisible: boolean;
  isFooterVisible: boolean;
  toggleHeaderFooter: () => void;
  toggleHeader: () => void;
  toggleFooter: () => void;
}

const UIVisibilityContext = createContext<UIVisibilityContextType | undefined>(undefined);

export const UIVisibilityProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [isFooterVisible, setIsFooterVisible] = useState(true);

  const toggleHeaderFooter = () => {
    setIsHeaderVisible(prev => !prev);
    setIsFooterVisible(prev => !prev);
  };

  const toggleHeader = () => {
    setIsHeaderVisible(prev => !prev);
  };

  const toggleFooter = () => {
    setIsFooterVisible(prev => !prev);
  };

  return (
    <UIVisibilityContext.Provider value={{
      isHeaderVisible,
      isFooterVisible,
      toggleHeaderFooter,
      toggleHeader,
      toggleFooter
    }}>
      {children}
    </UIVisibilityContext.Provider>
  );
};

export const useUIVisibility = () => {
  const context = useContext(UIVisibilityContext);
  if (context === undefined) {
    throw new Error('useUIVisibility must be used within a UIVisibilityProvider');
  }
  return context;
};
